var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-detail" } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("div", { staticClass: "detail-head" }, [
            _c("div", { staticClass: "head-color" }, [
              _c("div", { staticClass: "head-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "info-item",
                    on: {
                      click: function ($event) {
                        return _vm.copyToClipboard(_vm.visitor._id)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("badge"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(_vm._s(_vm.visitor._id)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "copy-icon material-icons" }, [
                      _vm._v("content_copy"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "info-separator" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("fiber_manual_record"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "info-item",
                    on: {
                      click: function ($event) {
                        _vm.copyToClipboard(
                          _vm.maskVisitorField("email", _vm.visitor.email) ||
                            _vm.$t("visitor.notAvailable")
                        )
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("email"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.maskVisitorField("email", _vm.visitor.email) ||
                            _vm.$t("visitor.notAvailable")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "copy-icon material-icons" }, [
                      _vm._v("content_copy"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "info-separator" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("fiber_manual_record"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "info-item",
                    on: {
                      click: function ($event) {
                        _vm.copyToClipboard(_vm.getChannelNameOrPlatform())
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "margin-right": "5px",
                          "margin-bottom": "-13px",
                        },
                      },
                      [
                        _vm.visitor
                          ? _c("PlatformIconViewer", {
                              staticStyle: { width: "16px", height: "16px" },
                              attrs: { platform: _vm.visitor.platform },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(_vm._s(_vm.getChannelNameOrPlatform())),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "copy-icon material-icons" }, [
                      _vm._v("content_copy"),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header-wrapper" }, [
              _c("div", { staticClass: "avatar-section" }, [
                _c(
                  "span",
                  { staticClass: "user-segment-avatar text-center" },
                  [
                    _vm.isBannedAnyPlatform()
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "top-center",
                                },
                                expression:
                                  "{ followCursor: true, placement: 'top-center' }",
                              },
                            ],
                            staticClass: "banned-frame",
                            attrs: {
                              content: _vm.$t("visitor.blockManagement"),
                            },
                            on: { click: _vm.ban },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("block"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "banned-text" }, [
                              _vm._v(_vm._s(_vm.$t("message.blocked"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ContactAvatar", {
                      staticStyle: {
                        "--background-color": "transparent",
                        width: "100px",
                        height: "90px",
                      },
                      attrs: { contact: _vm.visitor, badge: true },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-info-section" }, [
                _c("div", { staticClass: "user-name-row" }, [
                  _c("h1", { staticClass: "user-name" }, [
                    _vm._v(
                      _vm._s(
                        _vm.visitor.fullname
                          ? _vm.maskVisitorField(
                              "fullname",
                              _vm.visitor.fullname
                            )
                          : _vm.$t("visitor.defaultName")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vip-switch-container" },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "top-center",
                            },
                            expression:
                              "{ followCursor: true, placement: 'top-center' }",
                          },
                        ],
                        attrs: {
                          checked: _vm.visitor.vipCustomer,
                          "checked-children": "VIP",
                          "un-checked-children": "VIP",
                          content: _vm.$t("visitor.vipCustomer"),
                        },
                        on: { change: _vm.vipCustomerChange },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-email" }, [
                  _c("span", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.visitor.email
                            ? _vm.maskVisitorField("email", _vm.visitor.email)
                            : _vm.$t("visitor.noEmail")
                        ) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  !!_vm.visitor.emailVerified
                    ? _c("span", { staticClass: "material-icons mail-check" }, [
                        _vm._v("verified_user"),
                      ])
                    : _c("span", { staticClass: "mail-close" }, [
                        _vm._v(
                          "(" + _vm._s(_vm.$t("message.notVerified")) + ")"
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-segments-tags-row" }, [
                  _c(
                    "div",
                    { staticClass: "segment-chips" },
                    [
                      _vm._l(
                        _vm.selectedSegmentsList.slice(0, 1),
                        function (segment, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "segment-chip" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(segment.name) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm.selectedSegmentsList.length > 1
                        ? _c(
                            "div",
                            {
                              staticClass: "segment-chip more-chip",
                              on: {
                                click: function ($event) {
                                  _vm.segmentModalVisible = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                +" +
                                  _vm._s(_vm.selectedSegmentsList.length - 1) +
                                  "\n                            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "segment-chip add-segment-btn",
                          on: {
                            click: function ($event) {
                              _vm.segmentModalVisible = true
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("visitor.addSegment"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.selectedTagsList.slice(0, 1),
                        function (tag, index) {
                          return _c(
                            "div",
                            {
                              key: "tag-" + index,
                              staticClass: "segment-chip tag-chip",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons tag-icon" },
                                [_vm._v("local_offer")]
                              ),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(tag.name) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm.selectedTagsList.length > 1
                        ? _c(
                            "div",
                            {
                              staticClass: "segment-chip more-chip",
                              on: {
                                click: function ($event) {
                                  _vm.tagModalVisible = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                +" +
                                  _vm._s(_vm.selectedTagsList.length - 1) +
                                  "\n                            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "segment-chip add-segment-btn",
                          on: {
                            click: function ($event) {
                              _vm.tagModalVisible = true
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("visitor.addTag"))),
                          ]),
                        ]
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "quick-action-buttons" }, [
                  _c(
                    "div",
                    { staticClass: "action-icons" },
                    [
                      _vm.isWABusiness() ||
                      _vm.isWhatsappV1() ||
                      _vm.isWhatsappV2() ||
                      _vm.isWhatsappV3()
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "icon-btn",
                              attrs: { content: _vm.$t("visitor.startChat") },
                              on: {
                                click: function ($event) {
                                  return _vm.startWhatsappChat()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("chat"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "top-center",
                              },
                              expression:
                                "{ followCursor: true, placement: 'top-center' }",
                            },
                          ],
                          staticClass: "icon-btn",
                          attrs: { content: _vm.$t("visitor.createEvent") },
                          on: { click: _vm.openNewEvent },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("event"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "top-center",
                              },
                              expression:
                                "{ followCursor: true, placement: 'top-center' }",
                            },
                          ],
                          staticClass: "icon-btn",
                          attrs: { content: _vm.$t("visitor.createTask") },
                          on: {
                            click: function ($event) {
                              return _vm.createTask()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("assignment"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.visitorId
                        ? _c("ContactProfileAutomationButton", {
                            attrs: {
                              contactId: _vm.visitorId,
                              showText: false,
                              subMenuMode: "inline",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("AiVoiceAgentCallStarter", {
                        attrs: {
                          contact: _vm.visitor,
                          "default-to-number":
                            _vm.visitor.phone || _vm.visitor.whatsappNumber,
                          "hide-button": false,
                        },
                      }),
                      _vm._v(" "),
                      _vm.visitor.phone || _vm.visitor.whatsappNumber
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "icon-btn webphone-call-btn",
                              attrs: {
                                content: _vm.$t("visitor.webphoneCall"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.startWebphoneCall()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("phone"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isMetaPlatform()
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "icon-btn capi-event-btn",
                              attrs: {
                                content: _vm.$t("visitor.capiEventSend"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openCapiEventModal()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("ads_click"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "top-center",
                              },
                              expression:
                                "{ followCursor: true, placement: 'top-center' }",
                            },
                          ],
                          staticClass: "icon-btn",
                          attrs: { content: _vm.$t("visitor.blockManagement") },
                          on: {
                            click: function ($event) {
                              return _vm.ban()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("block"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.visitorDetailPermission
                        ? _c(
                            "div",
                            { staticClass: "more-menu" },
                            [
                              _c(
                                "a-dropdown",
                                [
                                  _c("button", { staticClass: "icon-btn" }, [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("more_horiz")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu",
                                    {
                                      staticClass:
                                        "visitor-detail-more-menu-dropdown",
                                      attrs: { slot: "overlay" },
                                      slot: "overlay",
                                    },
                                    [
                                      _vm.checkPermission(
                                        _vm.PERMISSION_TYPES["visitor.delete"]
                                          .tr.name
                                      )
                                        ? _c(
                                            "a-menu-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.deleteUserVisible = true
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "start",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons mr-2",
                                                      staticStyle: {
                                                        color: "#dc2626",
                                                      },
                                                    },
                                                    [_vm._v("delete")]
                                                  ),
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "visitor.deleteUser"
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.visitorTask && _vm.visitorTask.length > 0
                    ? _c(
                        "div",
                        { ref: "actionRight", staticClass: "action-right" },
                        [
                          _c(
                            "div",
                            { staticClass: "workflow-select-container" },
                            [
                              _c("div", { staticClass: "workflow-name" }, [
                                _c("span", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.visitorTask[_vm.selectedTaskIndex]
                                          .workflowId.title
                                      ) +
                                      "\n                                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "select" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "md-icon",
                                      staticStyle: {
                                        color: "#818793",
                                        "font-size": "20px !important",
                                      },
                                    },
                                    [_vm._v("assignment")]
                                  ),
                                  _vm._v(" "),
                                  _vm.visitorTask && _vm.visitorTask.length > 0
                                    ? _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            placeholder:
                                              _vm.$t("visitor.selectTask"),
                                          },
                                          model: {
                                            value: _vm.selectedTaskIndex,
                                            callback: function ($$v) {
                                              _vm.selectedTaskIndex = $$v
                                            },
                                            expression: "selectedTaskIndex",
                                          },
                                        },
                                        _vm._l(
                                          _vm.visitorTask,
                                          function (task, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: { value: index },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(task.title) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ticket-status-switcher-container" },
                            [
                              _vm.visitorTask && _vm.visitorTask.length > 0
                                ? _c("TicketStatusSwitcher", {
                                    attrs: {
                                      "status-list":
                                        _vm.visitorTask[_vm.selectedTaskIndex]
                                          .statusList,
                                      "current-status":
                                        _vm.visitorTask[_vm.selectedTaskIndex]
                                          .currentStatus,
                                      "default-color": "#91a2b6",
                                      "active-color": "#634eec",
                                      "hover-color": "#634eec",
                                      isVisitor: true,
                                    },
                                    on: {
                                      "update-status-visitor":
                                        _vm.handleStageChange,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-controls" }, [
                _c(
                  "div",
                  {
                    staticClass: "header-control-item preferred-agents-section",
                  },
                  [
                    _c("div", { staticClass: "control-label" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("support_agent"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("userInfoWidget.preferredAgents"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "control-content" },
                      [
                        _vm.visitor
                          ? _c("PreferredAgents", {
                              attrs: { visitorId: _vm.cloneVisitorId },
                              model: {
                                value: _vm.visitor.preferredAgents,
                                callback: function ($$v) {
                                  _vm.$set(_vm.visitor, "preferredAgents", $$v)
                                },
                                expression: "visitor.preferredAgents",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "header-control-item preferred-department-section",
                  },
                  [
                    _c("div", { staticClass: "control-label" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("group"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.preferredDepartment"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "control-content" },
                      [
                        _c("PreferredDepartment", {
                          attrs: { visitorId: _vm.cloneVisitorId },
                          model: {
                            value: _vm.visitor.preferredDepartment,
                            callback: function ($$v) {
                              _vm.$set(_vm.visitor, "preferredDepartment", $$v)
                            },
                            expression: "visitor.preferredDepartment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-control-item ownership-section" },
                  [
                    _c("div", { staticClass: "control-label" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("person_outline"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.customerOwnership"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "owner-select",
                        attrs: { value: _vm.getOwnerVal() },
                        on: { change: _vm.ownerChange },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("message.ownerless"))),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.users, function (user) {
                          return _c(
                            "a-select-option",
                            { key: user._id, attrs: { value: user._id } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(user.name) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-tabs" },
            [
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-details" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-details")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("person"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.profile")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-notes" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-notes")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("note"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.notes")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-activities" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-activities")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("history"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("wp.actions")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-chats" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-chats")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("chat"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.conversationHistory")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-mails" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-mails")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("email"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.mails")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-tasks" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-tasks")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.assignedTasks")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-events" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-events")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("event"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.calendar")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-media" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-media")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("image"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.sumChat_MediaFile")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-related-list" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-related-list")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("link"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("visitor.relatedList")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-ad-referrals" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-ad-referrals")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("ads_click"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("visitor.adReferrals")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.tabKey === "visitor-calls" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTabKey("visitor-calls")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("call"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("visitor.calls")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.visitor.metaLeadInfo
                ? _c(
                    "div",
                    {
                      staticClass: "tab-item",
                      class: { active: _vm.tabKey === "visitor-meta-lead" },
                      on: {
                        click: function ($event) {
                          return _vm.changeTabKey("visitor-meta-lead")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("leaderboard"),
                      ]),
                      _vm._v("\n                Meta Lead Form\n            "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.visitorDetailWebTabs, function (webTab) {
                return _c(
                  "div",
                  {
                    key: "webtab-" + webTab._id,
                    staticClass: "tab-item webtab-tab",
                    class: { active: _vm.tabKey === "webtab-" + webTab._id },
                    on: {
                      click: function ($event) {
                        return _vm.changeTabKey("webtab-" + webTab._id)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        style: {
                          color:
                            _vm.tabKey === "webtab-" + webTab._id
                              ? webTab.iconColor
                              : "",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(webTab.icon) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n                " +
                        _vm._s(webTab.name) +
                        "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.tabKey === "visitor-details"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-cards-grid" }, [
                    _c("div", { staticClass: "profile-card flex-1" }, [
                      _c("div", { staticClass: "visitor-card-header" }, [
                        _c("span", { staticClass: "visitor-card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "visitor-card-title" }, [
                          _vm._v(_vm._s(_vm.$t("visitor.generalInfo"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c("VisitorAttributes", {
                            attrs: {
                              visitor: _vm.visitor,
                              showOnlyGeneral: true,
                              isReadOnly: false,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-card flex-1" }, [
                      _c("div", { staticClass: "visitor-card-header" }, [
                        _c("span", { staticClass: "visitor-card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("person_outline"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "visitor-card-title" }, [
                          _vm._v(_vm._s(_vm.$t("visitor.profileFields"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c("VisitorAttributes", {
                            attrs: {
                              visitor: _vm.visitor,
                              showOnlyProfile: true,
                              isReadOnly: false,
                              metaReferralsBtn: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-notes"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("note"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("message.notes"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("VisitorNotes", {
                          attrs: {
                            notes: _vm.notes,
                            visitorId: _vm.cloneVisitorId,
                          },
                          on: { "note-added": _vm.fetchNotes },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-activities"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("history"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("message.visitorActions"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("VisitorActivities", {
                          attrs: { "visitor-id": _vm.cloneVisitorId },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-chats"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("chat"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("visitor.userChats"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "secondary-btn",
                            on: { click: _vm.seeAll },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("visibility"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("visitor.seeAll"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("VisitorChatList", {
                          attrs: { "visitor-id": _vm.cloneVisitorId },
                          on: { detailClose: _vm.closeModal },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-mails"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("email"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("message.visitorMails"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("VisitorMailList", {
                          attrs: {
                            visitorMail: _vm.visitor.email,
                            isGetChat: _vm.visibleMail,
                            visitorId: _vm.cloneVisitorId,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-tasks"
              ? _c(
                  "div",
                  { staticClass: "content-container" },
                  [
                    _c("div", { staticClass: "profile-card full-width" }, [
                      _c("div", { staticClass: "visitor-card-header" }, [
                        _c("span", { staticClass: "visitor-card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("check_circle"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "visitor-card-title" }, [
                          _vm._v(_vm._s(_vm.$t("message.assignedTasks"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body p-0" },
                        [
                          _c("VisitorTaskListView", {
                            attrs: { visitorId: _vm.cloneVisitorId },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-tooltip",
                      { attrs: { placement: "topLeft" } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("task.createTask"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "add-attribute-button",
                            on: {
                              click: function ($event) {
                                return _vm.createTask()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-events"
              ? _c(
                  "div",
                  { staticClass: "content-container" },
                  [
                    _c("div", { staticClass: "profile-card full-width" }, [
                      _c("div", { staticClass: "visitor-card-header" }, [
                        _c("span", { staticClass: "visitor-card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("event"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "visitor-card-title" }, [
                          _vm._v(_vm._s(_vm.$t("message.visitorEvents"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body p-0" },
                        [
                          _c("VisitorEventList", {
                            attrs: {
                              visitorId: _vm.cloneVisitorId,
                              newEvent: _vm.newEvent,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-tooltip",
                      { attrs: { placement: "topLeft" } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("visitor.createEvent"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "add-attribute-button",
                            on: { click: _vm.openNewEvent },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-media"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("image"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("message.sumChat_MediaFile"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body p-0" },
                      [
                        _c("VisitorMediaAndDocuments", {
                          attrs: { visitorId: _vm.cloneVisitorId },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-ad-referrals"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("ads_click"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("visitor.adReferrals"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body p-0" },
                      [
                        _c("MetaReferralList", {
                          attrs: { contact: _vm.visitor },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-related-list"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("link"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("visitor.relatedList"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body p-0" },
                      [
                        _c("ContactRelatedList", {
                          attrs: {
                            contactId: _vm.cloneVisitorId,
                            contact: _vm.visitor,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-calls"
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("call"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v(_vm._s(_vm.$t("visitor.callHistory"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body p-0" },
                      [
                        _c("VisitorCalls", {
                          key: "calls-" + _vm.cloneVisitorId,
                          attrs: {
                            visitorId: _vm.cloneVisitorId,
                            contact: _vm.visitor,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey === "visitor-meta-lead" && _vm.visitor.metaLeadInfo
              ? _c("div", { staticClass: "content-container" }, [
                  _c("div", { staticClass: "profile-card full-width" }, [
                    _c("div", { staticClass: "visitor-card-header" }, [
                      _c("span", { staticClass: "visitor-card-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("leaderboard"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "visitor-card-title" }, [
                        _vm._v("Meta Lead Form"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body meta-lead-info" }, [
                      _c("div", { staticClass: "meta-lead-grid" }, [
                        _c("div", { staticClass: "meta-lead-section" }, [
                          _c("h5", { staticClass: "meta-lead-section-title" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("campaign"),
                            ]),
                            _vm._v(
                              "\n                                    Kampanya Bilgileri\n                                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "meta-lead-fields" }, [
                            _vm.visitor.metaLeadInfo.campaign_name
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Kampanya"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "field-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.visitor.metaLeadInfo.campaign_name
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.adset_name
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Reklam Seti"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "field-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.visitor.metaLeadInfo.adset_name
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.ad_name
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Reklam"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "field-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.visitor.metaLeadInfo.ad_name)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.form_name
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Form"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "field-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.visitor.metaLeadInfo.form_name)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.platform
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Platform"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "field-value meta-lead-badge",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.visitor.metaLeadInfo.platform ===
                                            "ig"
                                            ? "Instagram"
                                            : _vm.visitor.metaLeadInfo
                                                .platform === "fb"
                                            ? "Facebook"
                                            : _vm.visitor.metaLeadInfo.platform
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.status
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Durum"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "field-value meta-lead-badge",
                                      class:
                                        "status-" +
                                        _vm.visitor.metaLeadInfo.status,
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.visitor.metaLeadInfo.status)
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.created_time
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Oluşturulma Tarihi"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "field-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$moment(
                                            _vm.visitor.metaLeadInfo
                                              .created_time
                                          )
                                          .format("DD.MM.YYYY HH:mm")
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.visitor.metaLeadInfo.field_data &&
                        _vm.visitor.metaLeadInfo.field_data.length
                          ? _c("div", { staticClass: "meta-lead-section" }, [
                              _c(
                                "h5",
                                { staticClass: "meta-lead-section-title" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("assignment")]
                                  ),
                                  _vm._v(
                                    "\n                                    Form Yanıtları\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "meta-lead-fields" },
                                _vm._l(
                                  _vm.visitor.metaLeadInfo.field_data,
                                  function (field, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "meta-lead-field",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "field-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                field.question
                                                  ? field.question.label
                                                  : field.name
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "field-value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                field.values
                                                  ? field.values.join(", ")
                                                  : "-"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "meta-lead-section" }, [
                          _c("h5", { staticClass: "meta-lead-section-title" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("fingerprint"),
                            ]),
                            _vm._v(
                              "\n                                    Teknik Bilgiler\n                                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "meta-lead-fields" }, [
                            _vm.visitor.metaLeadInfo.id
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Lead ID"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "field-value field-mono" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.visitor.metaLeadInfo.id)
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.form_id
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Form ID"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "field-value field-mono" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.visitor.metaLeadInfo.form_id)
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.ad_id
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Ad ID"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "field-value field-mono" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.visitor.metaLeadInfo.ad_id)
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.adset_id
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Adset ID"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "field-value field-mono" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.visitor.metaLeadInfo.adset_id
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.visitor.metaLeadInfo.campaign_id
                              ? _c("div", { staticClass: "meta-lead-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("Campaign ID"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "field-value field-mono" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.visitor.metaLeadInfo.campaign_id
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabKey.startsWith("webtab-")
              ? _c("div", { staticClass: "content-container webtab-content" }, [
                  _c(
                    "div",
                    { staticClass: "profile-card full-width webtab-card" },
                    [
                      _c("div", { staticClass: "visitor-card-header" }, [
                        _c("span", { staticClass: "visitor-card-icon" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              style: {
                                color: _vm.currentWebTab
                                  ? _vm.currentWebTab.iconColor
                                  : "",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.currentWebTab
                                      ? _vm.currentWebTab.icon
                                      : "tab"
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h4", { staticClass: "visitor-card-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.currentWebTab
                                ? _vm.currentWebTab.name
                                : _vm.$t("visitor.webTab")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body webtab-iframe-container" },
                        [
                          _vm.currentWebTabUrl
                            ? _c("iframe", {
                                staticClass: "webtab-iframe",
                                attrs: {
                                  src: _vm.currentWebTabUrl,
                                  frameborder: "0",
                                  allow:
                                    "camera; microphone; geolocation; fullscreen; autoplay; clipboard-read; clipboard-write",
                                  sandbox:
                                    "allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-downloads allow-top-navigation",
                                },
                              })
                            : _c("div", { staticClass: "webtab-error" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("error_outline"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("visitor.widgetUrlError"))
                                  ),
                                ]),
                              ]),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.segmentModalVisible
            ? _c("FormModal", {
                attrs: {
                  id: "add-to-segment",
                  title: _vm.$t("visitor.addSegment"),
                  footer: null,
                },
                on: {
                  cancel: function ($event) {
                    _vm.segmentModalVisible = false
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        var this$1 = this
                        return [
                          _c("div", { staticClass: "add-segment-search" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.segmentSearch,
                                  expression: "segmentSearch",
                                },
                              ],
                              staticStyle: { border: "none" },
                              attrs: {
                                placeholder: _vm.$t("visitor.filterName"),
                              },
                              domProps: { value: _vm.segmentSearch },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.segmentSearch = $event.target.value
                                  },
                                  _vm.segmentSearchChange,
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "material-icons mx-2 add-segment-search-icon",
                              },
                              [_vm._v(" search ")]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.filterSegments, function (filterSegment) {
                            return _c("VisitorAddSegment", {
                              key: filterSegment._id,
                              attrs: {
                                row: filterSegment,
                                "on-select-changed": function () {
                                  return _vm.segmentSelectChanged(filterSegment)
                                },
                                selectedSegments: _vm.selectedSegmentsList,
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "margin-top": "30px",
                              },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-segment-setting-btn",
                                  staticStyle: { display: "none" },
                                  on: {
                                    click: function () {
                                      return this$1.$router.push(
                                        "/chatbot/user-segments"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons mr-2",
                                      staticStyle: { "font-size": "20px" },
                                    },
                                    [_vm._v(" settings ")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("visitor.manageSegments"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-segment-confirm-btn",
                                  on: { click: _vm.segmentHandleCancel },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("visitor.confirm")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3072613556
                ),
                model: {
                  value: _vm.segmentModalVisible,
                  callback: function ($$v) {
                    _vm.segmentModalVisible = $$v
                  },
                  expression: "segmentModalVisible",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tagModalVisible
            ? _c("FormModal", {
                attrs: {
                  id: "add-to-tag",
                  title: _vm.$t("visitor.addTag"),
                  footer: false,
                },
                on: {
                  cancel: function ($event) {
                    _vm.tagModalVisible = false
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        var this$1 = this
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "add-segment-search",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tagSearch,
                                    expression: "tagSearch",
                                  },
                                ],
                                staticStyle: {
                                  border: "none",
                                  "border-radius": "5px",
                                  padding: "2px",
                                  width: "200px",
                                },
                                attrs: {
                                  placeholder: _vm.$t("visitor.filterName"),
                                },
                                domProps: { value: _vm.tagSearch },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.tagSearch = $event.target.value
                                    },
                                    _vm.tagSearchChange,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "material-icons mx-2 add-segment-search-icon",
                                },
                                [_vm._v(" search ")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.getFilteredTags(), function (filterTag) {
                            return _c("VisitorAddSegment", {
                              key: filterTag._id,
                              attrs: {
                                row: filterTag,
                                "on-select-changed": function () {
                                  return _vm.tagSelectChanged(filterTag)
                                },
                                selectedSegments: _vm.selectedTagsList,
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "margin-top": "30px",
                              },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "manage-tags-btn",
                                  staticStyle: { display: "none" },
                                  on: {
                                    click: function () {
                                      return this$1.$router.push("/tags")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons mr-2",
                                      staticStyle: { "font-size": "20px" },
                                    },
                                    [_vm._v(" settings ")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("visitor.manageTags"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-segment-confirm-btn",
                                  on: { click: _vm.tagHandleCancel },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("visitor.confirm")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1988946820
                ),
                model: {
                  value: _vm.tagModalVisible,
                  callback: function ($$v) {
                    _vm.tagModalVisible = $$v
                  },
                  expression: "tagModalVisible",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.deleteUserVisible
            ? _c(
                "div",
                {
                  staticClass: "custom-delete-modal-overlay",
                  on: {
                    click: function ($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      _vm.deleteUserVisible = false
                    },
                  },
                },
                [
                  _c("div", { staticClass: "custom-delete-modal" }, [
                    _c("div", { staticClass: "custom-modal-header" }, [
                      _c("div", { staticClass: "header-icon-wrapper" }, [
                        _c(
                          "span",
                          { staticClass: "material-icons header-icon" },
                          [_vm._v("warning")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("visitor.deleteUser"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close-btn",
                          on: {
                            click: function ($event) {
                              _vm.deleteUserVisible = false
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("close"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-modal-body" }, [
                      _c("div", { staticClass: "warning-message" }, [
                        _c(
                          "span",
                          { staticClass: "material-icons message-icon" },
                          [_vm._v("info")]
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("message.deleteVisitor"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "cancel-btn",
                          on: {
                            click: function ($event) {
                              _vm.deleteUserVisible = false
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("close"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.cancel")))]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "delete-btn",
                          on: {
                            click: function ($event) {
                              return _vm.deleteUser()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.delete")))]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.newEventModalVisible
            ? _c("CreateEventModal", {
                attrs: { calendarList: _vm.calendarList },
                on: {
                  close: function ($event) {
                    _vm.newEventModalVisible = false
                  },
                  editEvent: function ($event) {
                    return _vm.editEvent($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.visitor
        ? _c("VisitorBanModal", {
            attrs: {
              visitor: _vm.visitor,
              "ban-modal-visible": _vm.banModalVisible,
            },
            on: {
              close: function ($event) {
                _vm.banModalVisible = false
              },
              changed: _vm.visitorBanUpdated,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCapiEventModal
        ? _c("SendCapiEventModal", {
            attrs: { visible: _vm.showCapiEventModal, contact: _vm.visitor },
            on: {
              cancel: function ($event) {
                _vm.showCapiEventModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }